export function OutlineBillIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0603 18.9989V8.83045C19.0603 8.29779 18.8491 7.79392 18.4748 7.41482L14.6454 3.58544C14.2711 3.21114 13.7625 3 13.2298 3H7.00107C5.89736 3 5 3.89736 5 5.00107V18.9989C5 20.1026 5.89736 21 7.00107 21H17.064C18.1677 21 19.0651 20.1026 19.0651 18.9989H19.0603Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M13.0618 3.00391V7.28916C13.0618 8.23451 13.8296 9.00231 14.7749 9.00231H19.0602"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M14.281 12.2526C13.9019 11.9791 13.1005 11.4944 12.0304 11.504C11.5841 11.504 10.4852 11.5184 10.0533 12.2526C9.81817 12.6509 9.76539 13.2844 10.0533 13.7498C10.8115 14.9831 13.2541 14.0186 14.0075 15.247C14.2954 15.7173 14.2426 16.346 14.0075 16.7442C13.5852 17.4545 12.5534 17.4833 12.0976 17.4928C11.0035 17.5216 10.1733 17.0226 9.77979 16.7442"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M12.0303 10.002V11.504" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M12.0303 17.502V18.9992" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
